import EVImg from '@components/EVImg/EVImg';
import {
  CardContentDetailListStyled,
  CardContentWrapper,
  CardHeaderStyled,
  CardHeaderWrapper,
  CardSubHeaderStyled,
  ImageWrapper,
  MediaImageWrapper,
  StyledSpacer,
} from './style';

import ConditionallyWrapWithUrl from '@components/MiscComponents/ConditionallyWrapWithUrl';
import { FC } from 'react';
import { useTranslations } from 'next-intl';

//
//
//Shared nested components within multiple cards
//

//Generic Image Component
export interface CardImageProps {
  url?: string;
  //image: ResolvedImageData;
  image: string;
  alt_text?: string;
  imageAspectRatio?: number;
  extraPadding?: boolean;
  dataTestId?: string;
  type?:
    | 'propertyListing'
    | 'media'
    | 'article'
    | 'development'
    | 'shop'
    | 'pressRelease'
    | 'advisor';
}

//Generic Image Component
export const CardImage: FC<CardImageProps> = ({
  url,
  image,
  alt_text,
  imageAspectRatio = 0.75, // 4:3 by default
  type,
  dataTestId,
  ...rest
}) => {
  //take image ratio and muliply by 100 to get percentage and convert to string with percetary sign
  const imageRatio = (imageAspectRatio * 100).toString() + '%';

  return (
    <ImageWrapper data-testid={`${dataTestId}-wrapper`} {...rest} $imageAspectRatio={imageRatio}>
      <ConditionallyWrapWithUrl href={url}>
        <EVImg
          dataTestId={dataTestId}
          src={image}
          alt={alt_text}
          objectPosition={type === 'advisor' ? '50% 20%' : '50% 50%'}
          sizes={['500px']}
          loading="lazy"
        />
      </ConditionallyWrapWithUrl>
    </ImageWrapper>
  );
};

//Media Card Variant Image Component
export const MediaCardImage: FC<CardImageProps> = ({
  url,
  image,
  alt_text,
  imageAspectRatio = 0.75, // 4:3 by default
}) => {
  //take image ratio and muliply by 100 to get percentage and convert to string with percetary sign
  const imageRatio = (imageAspectRatio * 100).toString() + '%';

  return (
    <MediaImageWrapper $imageAspectRatio={imageRatio}>
      <ConditionallyWrapWithUrl href={url} target>
        <span>
          <span>
            <EVImg alt={alt_text} src={image} objectFit="contain" />
          </span>
        </span>
      </ConditionallyWrapWithUrl>
    </MediaImageWrapper>
  );
};

//Generic Header Component
export interface CardHeaderProps {
  url?: string;
  header: string;
  subHeader?: string;
  target?: boolean;
}
export const CardHeader = ({ url, target, header, subHeader }: CardHeaderProps) => {
  const t = useTranslations();
  return (
    <CardHeaderWrapper $subHeader={subHeader ? true : false} data-testid="advisor-name-title">
      <ConditionallyWrapWithUrl href={url} target={target}>
        <CardHeaderStyled $subHeader={!!subHeader}>{t(header as any)}</CardHeaderStyled>

        {subHeader && <CardSubHeaderStyled>{t(subHeader as any)}</CardSubHeaderStyled>}
      </ConditionallyWrapWithUrl>
    </CardHeaderWrapper>
  );
};

//Generic Wrapper of Card Content
export const CardContent = ({ children }) => {
  return <CardContentWrapper>{children}</CardContentWrapper>;
};

//List of Content Details
export const CardContentDetailList = ({ children }) => {
  return <CardContentDetailListStyled>{children}</CardContentDetailListStyled>;
};

// Small spacer for Media and Article Cards
export const CardSpacer = () => {
  return <StyledSpacer />;
};
